import { InfiniteData, useInfiniteQuery } from "@tanstack/react-query";
import { stakeholderApi } from "../api/stakeholder";


type StakeholdersResponse = {
    rows: any[];
    pagination: {
        total: number;
        limit: number;
        offset: number;
        page: number;
        totalPages: number;
        hasMore: boolean;
    };
};

export interface Stakeholders {
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  preferred_username: string;
  is_stake_holders: boolean;
  created_at: string;
  updated_at: string;
}

type QueryKey = ["stakeholders", string | undefined, string[] | null, boolean | null];

export const useInfiniteStakeholders = (params: {
    search?: string,
    region?: string[] | null
}) => {
    const { search, region } = params;

    const query = useInfiniteQuery<
        StakeholdersResponse,
        Error,
        InfiniteData<StakeholdersResponse>,
        QueryKey,
        number
    >({
        queryKey: ["stakeholders", search, region ?? null, null],

        queryFn: async({ pageParam = 1}) => {
            const response = await stakeholderApi.getStakeholders({
                page: pageParam,
                limit: 200,
                search,
                region: region ?? null
            });
            return response.data;
        },

        initialPageParam: 1,

        getNextPageParam: (lastPage) => {
            if(!lastPage?.pagination) return undefined;

            const { page, totalPages } = lastPage.pagination;
            return page < totalPages ? page + 1 : undefined;
        },
        enabled: true,
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 10
    });

    const stakeholders: Stakeholders[] = query.data?.pages.flatMap((page) => page.rows) ?? [];

    return { ...query, stakeholders};
}